<template>
    <div class="error404">
        <div class="page-404-content">
            <div class="container">
                <div class="row full-height">
                    <div class="col-md-12 text-center">
                        <div class="error-image section-space--mb_50">
                            <img class="img-fluid" src="../../assets/img/other/404.svg" alt="Image Not Found">
                        </div>
                        <div class="error-buttons section-space--mt_50">
                            <router-link class="ht-btn ht-btn-md" to="/">
                                 <span class="button-icon mr-2">
                                    <fa-icon :icon="['fas', 'home']" />
                                </span>
                                <span class="button-text">Zurück zur Startseite</span>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'NotFound'
    }
</script>